export const environment = {
  production: false,
  development:true,
  staging:false,
  designerBackendApi: 'https://dev.designer.spooorts.de/',
  designerFrontendApi:"https://dev.designer.se2.tech/",
  designerIframe:'https://dev.designeriframe.se2.tech/',
  loginApi:'https://dev.login.spooorts.de/login/',
  creatorAdminApi:'https://dev.creatoradmin.spooorts.de/',
  localhostTestApi:"http://localhost:8080/",

  spooortsEventApi:'https://dev.event.spooorts.de/',
  spooortsBa2Api:'https://dev.ba2.spooorts.de/',
  spooortsSportApi:'https://dev.sportevent.spooorts.de/',
  spooortsAdminApi:'https://spooorts.de/admin/',
  spooortsTournamentApi:'https://dev.tournament.spooorts.de/',
  spooortsBackofficeApi:'https://dev.backoffice.spooorts.de/',
  spooortsApi:'https://spooorts.de/'
};